(function () {
  var KEY = 'vejaFiltersRestore';
  var DELAY = 400;

  function init() {
    var form = document.getElementById('FacetFiltersFormMobile');
    if (!form || form.dataset.filtersBound) return;
    var details = form.closest('details.filter');
    if (!details) return;
    form.dataset.filtersBound = '1';

    var scroller = form.querySelector('.filters-scroll');
    var footer = form.querySelector('.filters-footer');
    var clearLink = footer ? footer.querySelector('a') : null;
    var applyBtn = footer ? footer.querySelector('button[type="submit"]') : null;
    var clearWrap = clearLink ? (clearLink.closest('x-cell') || clearLink) : null;
    var timer = null;
    var pending = false;

    function hasActive() {
      var active = false;
      new URLSearchParams(location.search).forEach(function (v, k) {
        if (k.indexOf('filter.') === 0 && v !== '') active = true;
      });
      return active;
    }

    // Clear all is only shown once a filter is applied
    if (clearLink) clearLink.setAttribute('data-filters-clear', '');
    if (clearWrap) clearWrap.style.display = hasActive() ? '' : 'none';

    // See Results shows the number of matching products, e.g. "See Results (74)"
    if (applyBtn && typeof window.vejaResultsCount === 'number' && window.vejaResultsCount >= 0) {
      applyBtn.textContent = applyBtn.textContent.trim() + ' (' + window.vejaResultsCount + ')';
    }

    function groups() {
      return scroller ? Array.prototype.slice.call(scroller.querySelectorAll(':scope > details')) : [];
    }

    // Filter group titles show how many options are selected, e.g. "Size (4)"
    function labelNode(group) {
      var summary = group.querySelector(':scope > summary');
      if (!summary) return null;
      for (var n = summary.firstChild; n; n = n.nextSibling) {
        if (n.nodeType === 3 && n.nodeValue.trim()) return n;
      }
      return null;
    }
    function updateCounts() {
      groups().forEach(function (g) {
        var node = labelNode(g);
        if (!node) return;
        if (g.dataset.baseLabel === undefined) g.dataset.baseLabel = node.nodeValue.trim();
        var count = g.querySelectorAll('input[type="checkbox"]:checked').length;
        node.nodeValue = '\n            ' + g.dataset.baseLabel + (count ? ' (' + count + ')' : '') + '\n            ';
      });
    }
    updateCounts();

    function saveState() {
      try {
        var open = [];
        groups().forEach(function (g, i) { if (g.open) open.push(i); });
        sessionStorage.setItem(KEY, JSON.stringify({
          t: Date.now(), p: location.pathname, g: open, s: scroller ? scroller.scrollTop : 0
        }));
      } catch (e) {}
    }
    function clearState() { try { sessionStorage.removeItem(KEY); } catch (e) {} }

    // Reopen the drawer after a filter-triggered reload
    try {
      var raw = sessionStorage.getItem(KEY);
      sessionStorage.removeItem(KEY);
      var s = raw && JSON.parse(raw);
      if (s && Date.now() - s.t < 15000 && s.p === location.pathname) {
        details.setAttribute('data-restoring', '');
        details.open = true;
        var gs = groups();
        (s.g || []).forEach(function (i) { if (gs[i]) gs[i].open = true; });
        if (scroller) {
          scroller.scrollTop = s.s || 0;
          window.addEventListener('load', function () {
            scroller.scrollTop = s.s || 0;
            setTimeout(function () { details.removeAttribute('data-restoring'); }, 400);
          });
        }
        if (document.readyState === 'complete') {
          setTimeout(function () { details.removeAttribute('data-restoring'); }, 400);
        }
      }
    } catch (e) { details.removeAttribute('data-restoring'); }

    function applyAndKeepOpen() {
      pending = false; timer = null;
      saveState();
      form.submit();
    }
    function applyAndStayClosed() {
      pending = false;
      clearTimeout(timer); timer = null;
      clearState();
      form.submit();
    }

    form.addEventListener('change', function () {
      updateCounts();
      pending = true;
      clearTimeout(timer);
      timer = setTimeout(applyAndKeepOpen, DELAY);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (pending) { applyAndStayClosed(); return; }
      details.removeAttribute('open');
      var summary = details.querySelector(':scope > summary');
      if (summary) summary.focus();
    });

    if (clearLink) {
      clearLink.addEventListener('click', function () {
        clearTimeout(timer); timer = null; pending = false;
        saveState();
      });
    }

    details.addEventListener('toggle', function () {
      if (!details.open) {
        clearState();
        if (pending) applyAndStayClosed();
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
